import { apiFetch } from 'utils/apiFetch'

export const serviceCenterNodeLogsGet = async (propertyIds: number[]) => {
  const nodeLogs = await apiFetch({ url: '/service-center-node-logs-get', body: { propertyIds } })

  return nodeLogs
}
